import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { BenefitCard, SwiperController } from '../../basic';
SwiperCore.use([Pagination]);
const SwiperMobile = (props) => {
    const { data, visible } = props;
    const [chunkSize,] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const swiperRef = useRef(null);
    const benefitChunks = [];
    if (!data || !visible)
        return null;
    for (let i = 0; i < data.length; i += chunkSize) {
        benefitChunks.push(data.slice(i, i + chunkSize));
    }
    const onNext = () => {
        if (currentPage < data.length) {
            setCurrentPage(currentPage + 1);
            swiperRef.current.swiper.slideNext();
        }
    };
    const onPrev = () => {
        if (currentPage - 1) {
            setCurrentPage(currentPage - 1);
            swiperRef.current.swiper.slidePrev();
        }
    };
    return _jsxs(_Fragment, { children: [_jsx(Swiper, { ref: swiperRef, slidesPerView: 1.5, centeredSlides: true, spaceBetween: 30, modules: [Pagination], className: "benefit-swiper", onSlideChange: (swiper) => setCurrentPage(swiper.activeIndex + 1), initialSlide: currentPage - 1, children: data.map((benefitCard, index) => {
                    return (_jsx(SwiperSlide, { children: _jsx(BenefitCard, { image: benefitCard.image, label: benefitCard.label, index: index, plainText: benefitCard.plainText }) }, `key_benefit_mobile_${benefitCard.label}`));
                }) }), _jsx(SwiperController, { currentPage: currentPage, totalPage: data.length, onNext: onNext, onPrev: onPrev })] });
};
export default SwiperMobile;
